// Opciones para el tipo de cliente
// Representa las distintas categorías en las que se puede clasificar a un cliente.
const tipoClienteOptions = [
    { value: "Sin tipo", label: "Sin tipo" }, // Sin categoría específica
    { value: "Corporativo", label: "Corporativo" }, // Clientes corporativos
    { value: "Agencia", label: "Agencia" }, // Clientes de agencias
    { value: "Social", label: "Social" }, // Clientes de eventos sociales
    { value: "Interno", label: "Interno" }, // Uso interno
];

// Opciones para el estado de crédito del cliente
// Define si un cliente tiene o no crédito aprobado.
const creditoOptions = [
    { value: "No", label: "No" }, // Sin crédito
    { value: "Si", label: "Sí" }, // Con crédito
];

// Opciones para los grupos a los que puede pertenecer el cliente
// Utilizado para segmentar clientes en categorías funcionales.
const gruposOpciones = [
    { value: "AYB", label: "AYB" }, // Alimentos y bebidas
    { value: "otros", label: "otros" }, // Otros grupos no especificados
    { value: "AV", label: "AV" }, // Audiovisuales
    { value: "Rooms", label: "Rooms" }, // Habitaciones
];

// Opciones para seleccionar el hotel
// Proporciona una lista de hoteles disponibles con colores asociados para mejor visualización.
const hotelesOpciones = [
    { value: "1", label: "Hilton Garden Inn Santa Ana", backgroundColor: "#dc3545" }, // Hilton con color rojo
    { value: "2", label: "Wyndham Garden Escazú", backgroundColor: "#198754" }, // Wyndham con color verde
    { value: "3", label: "Holiday Inn", backgroundColor: "#0d6efd" }, // Holiday Inn con color azul
    { value: "4", label: "Otro", backgroundColor: "#6c757d" }, // Otro con color gris
];

// Opciones para determinar si un servicio aplica impuestos
// Se utiliza para definir la política fiscal en transacciones.
const impuestosOpciones = [
    { value: 1, label: "Sí aplica" }, // Aplica impuestos
    { value: 0, label: "No aplica" }, // No aplica impuestos
];

// Lista de logos disponibles con su respectivo ID y ruta
// Asociados a diferentes hoteles para personalización de branding.
const logos = [
    { id: 1, logo: "/logos/santaana.jpg" }, // Logo de Hilton Garden Inn Santa Ana
    { id: 2, logo: "/logos/win.jpg" }, // Logo de Wyndham Garden Escazú
    { id: 3, logo: "/logos/hol.png" }, // Logo de Holiday Inn
];

// Lista de etiquetas disponibles
// Cintillos gráficos para diferenciar elementos visualmente.
const etiquetas = [
    { id: 1, logo: "/cintillo/Cintillo1.png" }, // Primer cintillo
    { id: 2, logo: "/cintillo/Cintillo2.png" }, // Segundo cintillo
    { id: 3, logo: "/cintillo/Cintillo3.png" }, // Tercer cintillo
];

// Lista de estados
// Representa los posibles estados de eventos o servicios, con un color asociado y su estado lógico (activo/inactivo).
const estadosEvento = [
    { id_estado: 1, nombre_estado: "Confirmado", color_estado: "#A1E450", status_estado: 1 }, // Evento confirmado (color verde)
    { id_estado: 2, nombre_estado: "Tentativo", color_estado: "#C5BED1", status_estado: 1 }, // Evento tentativo (color gris)
    { id_estado: 3, nombre_estado: "Evento Interno", color_estado: "#A3A9F7", status_estado: 1 }, // Evento interno (color azul)
    { id_estado: 4, nombre_estado: "Fuera de Servicio", color_estado: "#FA8458", status_estado: 1 }, // Fuera de servicio (color rojo)
];

// Opciones para el tipo de eventos
 const tiposDeeventosSelect = [
     { value: "", label: "Escoger" },
     { value: "Social", label: "Social" },
     { value: "Corporativo", label: "Corporativo" },
     { value: "Interno", label: "Interno" },
 ];
// Exportar todas las opciones
// Centraliza todas las listas de opciones para facilitar su reutilización en otras partes de la aplicación.
export { tipoClienteOptions, creditoOptions, gruposOpciones, hotelesOpciones, impuestosOpciones, logos, etiquetas, estadosEvento, tiposDeeventosSelect };
